import PropTypes from "prop-types"
import React from "react"

const { createContext, useState } = React
const AccountContext = createContext(null)

function AccountContextProvider(props) {
  const [accounts, setAccounts] = useState(props.accounts || [])
  const [cloudabilityData, setCloudabilityData] = useState("")
  const [selectedAccounts, setSelectedAccounts] = useState(
    props.selectedAccounts || []
  )
  const [isEmptyAccSelected, setIsEmptyAccSelected] = useState(true)
  const [projectBonding, setProjectBonding] = useState({})
  const [projectBondLoading, setProjectBondLoading] = useState(true)
  const [isSmallScreen, setIsSmallScreen] = useState(false)
  const setAllAccounts = (accounts) => {
    setAccounts(accounts)
    if (selectedAccounts.length === 0) {
      setSelectedAccounts(accounts)
    }
  }

  return (
    <AccountContext.Provider
      value={{
        accounts,
        selectedAccounts,
        setAllAccounts,
        setSelectedAccounts,
        cloudabilityData,
        setCloudabilityData,
        isEmptyAccSelected,
        setIsEmptyAccSelected,
        projectBonding,
        setProjectBonding,
        projectBondLoading,
        setProjectBondLoading,
        isSmallScreen,
        setIsSmallScreen
      }}
    >
      {props.children}
    </AccountContext.Provider>
  )
}

AccountContextProvider.propTypes = {
  accounts: PropTypes.array,
  selectedAccounts: PropTypes.array,
  children: PropTypes.node
}

export default AccountContext
export { AccountContextProvider }
